<template>
  <div class="snow-steps">
    <div
      v-for="(step, i) in steps"
      :key="i"
      class="wrapper"
      :class="getClasses(i)"
    >
      <div class="step">
        <div class="step-button" @click="click(i)">
          <div class="current-step">
            <i v-if="isDone(i)" class="ph ph-check" />
            <div v-else>
              {{ i + 1 }}
            </div>
          </div>
          <div class="title">{{ step }}</div>
        </div>
      </div>

      <div v-if="!isLastStep(i)" class="divider">
        <div class="line" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 1
    },
    steps: {
      type: Array,
      required: true
    },
    navigable: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click(i) {
      if (this.navigable) this.$emit("input", i + 1);
    },
    isLastStep(i) {
      return i === this.steps.length - 1;
    },
    isDone(i) {
      return this.value > i + 1;
    },
    getClasses(i) {
      return {
        done: this.isDone(i),
        focused: this.value === i + 1,
        navigable: this.navigable,
        fullWidth: this.fullWidth,
        first: i === 0,
        last: this.isLastStep(i)
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.snow-steps {
  display: flex;
  gap: 8px;
  flex: 1;
  min-width: 0;

  .wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow: hidden;

    .step {
      display: flex;
      overflow: hidden;
      .step-button {
        display: flex;
        align-items: center;
        gap: 8px;
        overflow: hidden;

        .title {
          color: var(--dark-40);
          white-space: nowrap;
          overflow: hidden;
          max-width: 100%;
          text-overflow: ellipsis;
          transition: color 0.2s;
          font-size: 14px;
        }

        .current-step {
          display: flex;
          justify-content: center;
          align-items: center;
          min-width: 32px;
          min-height: 32px;

          border: 1px solid;
          border-radius: 50%;
          border-color: var(--dark-10);
          transition: all 0.2s;
          color: var(--dark-40);
          background-color: white;
        }
      }
    }

    .divider {
      display: flex;
      align-items: center;
      .line {
        width: 43px;
        border: 1px solid;
        color: var(--dark-20);
      }
    }

    &.fullWidth {
      flex: 1;

      .divider {
        flex: 1;

        .line {
          flex: 1;
          width: 100%;
        }
      }

      &.focused {
        flex: 1;
      }
      &.last {
        flex: none;
      }
    }

    &.navigable {
      transition: all 0.2s ease-in-out;
      &:hover {
        flex: none;
      }

      .step-button {
        cursor: pointer;
        &:hover {
          .title {
            color: var(--blue);
          }
        }

        &:active {
          .title {
            color: var(--dark-40);
          }
        }
      }
    }

    // Changes according to the step state
    &.focused {
      flex: none;
      .step-button {
        .current-step {
          color: white;
          border-color: var(--blue);
          background-color: var(--blue);
        }
        .title {
          color: var(--blue);
        }
      }
      &.navigable {
        .step-button {
          cursor: default;
        }
      }
    }

    &.done {
      .step-button {
        .current-step {
          color: white;
          border-color: var(--blue);
          background-color: var(--blue);
        }
      }
    }
  }

  @media screen and (max-width: 991px) {
    flex: 1;
    .wrapper {
      flex: 1;

      .title {
        display: none;
      }

      .divider {
        flex: 1;

        .line {
          flex: 1;
          width: 100%;
        }
      }

      &.focused {
        flex: 1;
      }

      &.last {
        flex: none;
      }

      &.navigable {
        &:hover {
          flex: 1;
        }
        &.last {
          flex: none;
        }
      }
    }
  }
}
</style>
